// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* .btn {\n  background: $secondary-color;\n} */\n.control-bar-container, .control-bar-container .row {\n  height: 100%;\n  background-color: #151515;\n}", ""]);
// Exports
module.exports = exports;
